module.exports = __webpack_public_path__ + "static/img/hibe-large-icon.d3f2f613.png";